import { api, apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArchiveRestore } from "lucide-react";
import { toast } from "sonner";

// Read-only browse of archived projects with a per-row Restore (unarchive) action.
export function ArchiveView({ items, onOpen, onChanged }) {
  const restore = async (id, e) => {
    e.stopPropagation();
    try {
      await api.post(`/projects/${id}/unarchive`);
      toast.success("Project restored to your active list");
      onChanged();
    } catch (err) { toast.error(apiError(err)); }
  };

  if (!items?.length) {
    return (
      <Card className="shadow-none p-12 text-center" data-testid="archive-empty">
        <h3 className="font-display text-xl font-bold">No archived projects</h3>
        <p className="text-muted-foreground mt-2 text-sm max-w-md mx-auto">
          Archive projects (from here or Admin ▸ Projects) to tuck completed or inactive work out of the main list.
          They stay safe and can be restored any time.
        </p>
      </Card>
    );
  }

  return (
    <div className="space-y-2" data-testid="archive-view">
      {items.map((p) => (
        <Card key={p.id} data-testid={`archive-row-${p.id}`} onClick={() => onOpen(p)}
          className="shadow-none p-4 flex items-center justify-between gap-4 cursor-pointer hover:border-primary/50 transition-colors">
          <div className="min-w-0">
            <div className="font-semibold truncate">{p.name}</div>
            <div className="text-xs text-muted-foreground truncate">
              {p.client_name || "-"} · {p.country || "-"} · updated {p.updated_at ? new Date(p.updated_at).toLocaleDateString() : "-"}
            </div>
          </div>
          <Button size="sm" variant="outline" onClick={(e) => restore(p.id, e)} data-testid={`archive-restore-${p.id}`}>
            <ArchiveRestore size={14} className="mr-1.5" /> Restore
          </Button>
        </Card>
      ))}
    </div>
  );
}
